module.exports = __webpack_public_path__ + "img/9bab42c.jpg";